import React from 'react'

import {ViewTypeConfigs} from "../../../../../core/gd/const/views/view-type-config"

type Props = {
    title           : string
    items           : any[]

    onSelect?       : func,
    onItemSelect?   : func       // same as onSelect - used to pass item
    onUpgrade?      : func
}

// const debug = "ItemTypeList"
const debug = false

export default function ItemTypeList(props: Props) {

    const onSelect = (item:any) => {
        debug && console.log(debug, 'onSelect', item)

        if (item.alreadyExists) {
            //@ts-ignore
            const viewConfig = ViewTypeConfigs[item.typeId];
            gd.goTo(viewConfig.url);
            return;
        }

        if (item.isPro) {
            props.onUpgrade && props.onUpgrade();
        } else {
            if (item.onClick) {
                item.onClick()
            } else {
                props.onSelect?.(item.typeId, item.id)
            }

            props.onItemSelect?.(item)
        }
    }

    return (
        <div className="item-type-group-new">
            {props.title &&
                <div className="group-title">
                    <div className="label">{props.title}</div>
                    <div className="line-through"/>
                </div>}

            {/*{props.title &&*/}
            {/*    <div className="group-title2">*/}
            {/*        <div className="label">{props.title}</div>*/}
            {/*    </div>}*/}

            <div className="item-group-center">
                {props.items.map((item: any, key: number) => {
                    const classes = Classes("item-type-option", {
                        "is-premium": item.isPro,
                        "already-exists": item.alreadyExists
                    })

                    return (
                        <div key={'{0}_{1}_{2}'.f(key, item.typeId, item.id)}
                             className={classes}
                             onClick={() => onSelect(item)}>

                            {item.icon && <div className={Classes('option-icon', item.icon)}/>}
                            {item.image && <div className={Classes("svg-icon", 's45', item.image)}/>}
                            {item.svgIcon50 && <div className={Classes("svg-icon-50 size-50", item.svgIcon50)}/>}
                            {item.iconComponent}

                            <div className="option">
                                <div className="option-title max-w-200">
                                    {item.title}
                                    {item.alreadyExists &&
                                        <div className="ui5-status-list status-c0 s18 m-l-10 ">Added</div>}
                                    {item.isPro && <div className="option-pro ui5-ico-pro"/>}
                                </div>
                                <div className="option-description max-w-200 txt-truncate">{item.description}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
